import { useContext } from 'react';
import UILink from 'UIComponents/link/UILink';
import UsageTrackerContext from '../context/UsageTrackerContext';
import { getNavigateToCompanyRecord } from '../constants/events';
import styled from 'styled-components';
import UITruncateString from 'UIComponents/text/UITruncateString';
import RecordLink from 'crm-links/record/RecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecordLink = styled(RecordLink).withConfig({
  displayName: "CompanyName__StyledRecordLink",
  componentId: "jo5w8u-0"
})(["@media screen and (max-width:1110px){max-width:150px;}@media screen and (max-width:1500px) and (min-width:1111px){max-width:200px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:500px;}@media screen and (min-width:2001px){max-width:1150px;}"]);
const StyledLink = styled(UILink).withConfig({
  displayName: "CompanyName__StyledLink",
  componentId: "jo5w8u-1"
})(["@media screen and (max-width:1110px){max-width:150px;}@media screen and (max-width:1500px) and (min-width:1111px){max-width:200px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:500px;}@media screen and (min-width:2001px){max-width:1150px;}"]);
const CompanyName = ({
  associatedCompanyId,
  companyName,
  companyLink,
  includeEschref
}) => {
  const trackEvent = useContext(UsageTrackerContext);
  if (!companyLink) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      matchContentWidth: true,
      children: companyName
    });
  }
  if (includeEschref) {
    return /*#__PURE__*/_jsx(StyledRecordLink, {
      "data-test-id": "inbox-header-company-link",
      includeEschref: includeEschref,
      LinkComponentProps: {
        truncate: true,
        truncateStringProps: {
          useFlex: true
        }
      },
      objectId: +associatedCompanyId,
      objectTypeId: "0-2",
      onTrackClick: () => trackEvent(getNavigateToCompanyRecord()),
      children: companyName
    });
  }
  return /*#__PURE__*/_jsx(StyledLink, {
    href: companyLink,
    external: true,
    onClick: () => trackEvent(getNavigateToCompanyRecord()),
    truncate: true,
    truncateStringProps: {
      useFlex: true
    },
    "data-test-id": "inbox-header-company-link",
    children: companyName
  });
};
CompanyName.displayName = 'CompanyName';
export default CompanyName;